"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const simulation_1 = require("./simulation");
document.addEventListener("DOMContentLoaded", () => {
    new simulation_1.Simulation().start();
});
//# sourceMappingURL=app.js.map